// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatchDeletion\ApiRecurringBatchDeletion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BatchRecurrencePeriod, BatchRecurrencePeriodData, BatchRecurrencePeriodOptions } from 'data/models/BatchRecurrencePeriod';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { PortCallDeletion, PortCallDeletionData, PortCallDeletionOptions } from 'data/models/PortCallDeletion';

// RecurringBatchDeletionData is the class that RecurringBatchDeletion serializes to/from
export interface RecurringBatchDeletionData {
    Id : number;
	
    Event : EventData | null;
    EventId : number;
    PortCallDeletions : PortCallDeletionData[] | null;
	
    RecurrencePeriod : BatchRecurrencePeriodData;
    RecurringBatchGuid : /* GUID */ string;
    ReferenceNumber : string;
    RequestDate : /* ISO8601 */ string;
    ReservationCount : number;
}

// RecurringBatchDeletionOptions is the class which may be passed to the RecurringBatchDeletion constructor to define optional initial data values
export interface RecurringBatchDeletionOptions {
    Id : number;
	
    Event? : EventOptions | null;
    EventId? : number;
    PortCallDeletions? : PortCallDeletionOptions[] | null;
	
    RecurrencePeriod? : BatchRecurrencePeriodOptions;
    RecurringBatchGuid? : /* GUID */ string;
    ReferenceNumber? : string;
    RequestDate? : /* ISO8601 */ string;
    ReservationCount? : number;
}

export class RecurringBatchDeletion {
    public Id : DataSignal<number>;
	
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public PortCallDeletions : SDataArray<PortCallDeletion>;
	
    public RecurrencePeriod : BatchRecurrencePeriod;
    public RecurringBatchGuid : DataSignal<string>;
    public ReferenceNumber : DataSignal<string>;
    public RequestDate : DataSignal<TZDate>;
    public ReservationCount : DataSignal<number>;

    constructor();
    constructor(data : RecurringBatchDeletionOptions);
    constructor(data: RecurringBatchDeletionOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.PortCallDeletions = SArray<PortCallDeletion>([]);
	    
        this.RecurrencePeriod = data && data.RecurrencePeriod !== undefined ? new BatchRecurrencePeriod(data.RecurrencePeriod) : new BatchRecurrencePeriod();
        this.RecurringBatchGuid = jsonableObservable(S.value<string>(data && data.RecurringBatchGuid !== undefined ? data.RecurringBatchGuid : '00000000-0000-0000-0000-000000000000'));
        this.ReferenceNumber = jsonableObservable(S.value<string>(data && data.ReferenceNumber !== undefined ? data.ReferenceNumber : ''));
        this.RequestDate = jsonableObservable(S.value<TZDate>(data && data.RequestDate !== undefined ? new TZDate(data.RequestDate) : new TZDate(0), TZDate.eq));
        this.ReservationCount = jsonableObservable(S.value<number>(data && data.ReservationCount !== undefined ? data.ReservationCount : 0));
    }

    static key(obj : RecurringBatchDeletion) {
        return obj.Id();
    }
    
    static dataKey(obj : RecurringBatchDeletionOptions) {
        return obj.Id;
    }

    static update(obj : RecurringBatchDeletion, data : RecurringBatchDeletionOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.EventId !== undefined) obj.EventId(data.EventId);
	        
            if (data.RecurrencePeriod !== undefined) BatchRecurrencePeriod.update(obj.RecurrencePeriod, data.RecurrencePeriod);
            if (data.RecurringBatchGuid !== undefined) obj.RecurringBatchGuid(data.RecurringBatchGuid);
            if (data.ReferenceNumber !== undefined) obj.ReferenceNumber(data.ReferenceNumber);
            if (data.RequestDate !== undefined) obj.RequestDate(new TZDate(data.RequestDate));
            if (data.ReservationCount !== undefined) obj.ReservationCount(data.ReservationCount);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/RecurringBatchDeletion.ts